import bow from './icon_bow.png'
import catalyst from './icon_catalyst.png'
import claymore from './icon_claymore.png'
import polearm from './icon_polearm.png'
import sword from './icon_sword.png'

import fragile from './Item_Fragile_Resin.png'
import condensed from './Item_Condensed_Resin.png'

//EXP BOOKS
import advice from './Item_Wanderer\'s_Advice.png'
import wit from './Item_Hero\'s_Wit.png'
import experience from './Item_Adventurer\'s_Experience.png'

const Assets = {
  weaponTypes: { bow, catalyst, claymore, polearm, sword },
  resin: {
    fragile,
    condensed
  },
  exp_books: {
    advice,
    wit,
    experience,
  }
};
export default Assets;